// stripe-config.js
import { loadStripe } from '@stripe/stripe-js';

// Remplacez par votre clé publique Stripe
const stripePublicKey = 'pk_live_51RnyGlGirb6zLStUmh5430EGHBOQLWKlyyi2AC6MK9RC8kS9qWyXp8EHebVRNrzFjKEjdiaw8Grc9B6Bsyfu0ZTC00onSTTHDg';

export const stripePromise = loadStripe(stripePublicKey);